import { isMobile, isTablet } from "react-device-detect";
export const isMobileTablet = () => {
    // const isMobileView = window.matchMedia('(max-width: 1220px)').matches;
    // const userAgent = navigator.userAgent.toLowerCase();
    // const isMobileAgent = /iphone|ipod|android|blackberry|windows phone/g.test(userAgent);
    // var ua = navigator.userAgent,
    // isWindowsPhone = /(?:Windows Phone)/.test(ua),
    // isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    // isAndroid = /(?:Android)/.test(ua),
    // isFireFox = /(?:Firefox)/.test(ua),
    // isChrome = /(?:Chrome|CriOS)/.test(ua),
    // isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    // isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    // isPc = !isPhone && !isAndroid && !isSymbian;
    return isTablet || isMobile;
};

export const openNewWindow = (url) => {
    window.open(url, "_blank");
};

export const debounce = (func, delay) => {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};

export const validateEmail = (email) => {
    // 基础格式快速校验
    if (!email || email.indexOf("@") === -1) return false;

    // RFC 5322 标准正则表达式
    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailRegex.test(email);
};


export function getIntegerAndFraction(num) {
  const [integerStr, fractionStr = '00'] = String(num.toFixed(2)).split('.');
  return {
    integer: integerStr,
    fraction:'.' + fractionStr
  };
}


export function getRemainingDays(createdAt, offsetDays = 180) {
    const createDate = new Date(createdAt);
    if (isNaN(createDate.getTime())) throw new Error('Invalid createdAt');
  
    const endDate = new Date(createDate);
    endDate.setDate(createDate.getDate() + offsetDays);
  
    const now = new Date();
    const diffMs = endDate.getTime() - now.getTime();
    const diff1 = Math.ceil((now.getTime() - createDate.getTime()) / (1000 * 60 * 60 * 24))
    const diff2 = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
    return {diff1, diff2 };
  }

  export function formatDateTime(date) {
    const d = new Date(date);
    if (isNaN(d.getTime())) return 'Invalid Date';
  
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
  
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  }

  export function formatDate(date) {
    const d = new Date(date);
    if (isNaN(d.getTime())) return 'Invalid Date';
  
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
  
    return `${year}/${month}/${day}`;
  }



  export const formatAddress = (address) => {
    if (!address) return '';
    return `${address.slice(0, 6)}***${address.slice(-4)}`;
  }
  